import { render, staticRenderFns } from "./ReporteServiciosWellboatsNew.vue?vue&type=template&id=16cdaf24&scoped=true"
import script from "./ReporteServiciosWellboatsNew.vue?vue&type=script&lang=js"
export * from "./ReporteServiciosWellboatsNew.vue?vue&type=script&lang=js"
import style0 from "./ReporteServiciosWellboatsNew.vue?vue&type=style&index=0&id=16cdaf24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cdaf24",
  null
  
)

export default component.exports